import { render, staticRenderFns } from "./MagicLinkPost.vue?vue&type=template&id=c637300a&scoped=true&"
import script from "./MagicLinkPost.vue?vue&type=script&lang=js&"
export * from "./MagicLinkPost.vue?vue&type=script&lang=js&"
import style0 from "./MagicLinkPost.vue?vue&type=style&index=0&id=c637300a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c637300a",
  null
  
)

export default component.exports